// extracted by mini-css-extract-plugin
export default {"root":"fhf6MlF0jymHYAbXp5lp","placeHolderShimmer":"vqXvmyQVckaCMHX4_vcA"};